
import { defineComponent } from 'vue';
import EnlargeIcon from '@/components/icons/EnlargeIcon.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import { baseFileUrl } from '@/utils/constants';
import MultiStatusModal from '@/components/multi-status/MultiStatusModal.vue';

interface DiagramItemProps {
  previewImg: string[];
  [key: string]: any;
}

export default defineComponent({
  name: 'CatalogueItem',
  components: {
    EnlargeIcon,
    PreviewImageModal,
    MultiStatusModal
  },
  data(): DiagramItemProps {
    return {
      baseFileUrl,
      showPreviewModal: false,
      previewImg: [],
      showMultiStatusModal: false
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    prePageNo: {
      type: Number,
      required: true,
      default: () => {
        return 1;
      }
    },
    vehicleId: {
      type: Number,
      required: true,
      default: () => {
        return 1;
      }
    }
  },
  computed: {
    getImg() {
      let res = '';
      const partsImgs = this.item.partsImgs || [];

      if (partsImgs.length > 0) {
        if (partsImgs[0].fileUrl) {
          res = baseFileUrl + partsImgs[0].fileUrl;
        }
      }

      return res;
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.d-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    onImgClick() {
      this.previewImg.push(this.getImg);
      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showPreviewModal = false;

      this.previewImg = [];
    },
    async handleAfterMultiStatusClose(data, isCancel) {
      this.showMultiStatusModal = false;
      if (isCancel) {
        return;
      }
      if (data) {
        localStorage.setItem('diagramPageNo', this.prePageNo.toString());
        this.$router.push(`/part-detail/${data.diagramId}/${this.vehicleId}`);
      }
    },
    gotoPart() {
      if (this.item.differentStatus === 1) {
        this.showMultiStatusModal = true;
      } else {
        localStorage.setItem('diagramPageNo', this.prePageNo.toString());
        this.$router.push(`/part-detail/${this.item.id}/${this.vehicleId}`);
      }
    }
  }
});
